import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { ModalChiTietSoNo } from "./ModalChiTietSoNo";
export const BtnChiTietSoDuNo = ({ item }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div>
        <a onClick={handleShow} href={() => false} className="blue btn-link">
          {formatNumber(item.DuNo)}
        </a>
        {handleClose && show &&  (
          <ModalChiTietSoNo
            show={show}
            onHide={handleClose}
            userId={item.UserID}
            FirstName={item.FirstName}
          />
        )}
      </div>
    </>
  );
};
